import { createContext } from 'react';
import { IOpenWidgetParams } from '../../types/microfrontends/newbuildingCallbackWidget';

/* istanbul ignore next */
export const NewbuildingCallbackWidgetContext = createContext<(params: IOpenWidgetParams) => Promise<void>>(() =>
  Promise.resolve(),
);
